import { useEffect, useState } from "react";

/**
 * s237 (ACROSS-YOUR-PLAN-1 PR C; D-237.34, rule 159) — one-click copy, built once: an email, a phone, an address (board 12:
 * "a copy button beside every email, phone and street address"; codes never copy). The icon becomes a tick for a moment
 * once copied. A copy the browser refuses leaves the icon as it was.
 */
const COPY = "M9 9h10v12H9zM5 15V3h10";
const DONE = "M20 6 9 17l-5-5";

export function CopyButton({ text, title, testId }: { text: string; title: string; testId: string }) {
  const [copied, setCopied] = useState(false);
  useEffect(() => {
    if (!copied) return;
    const t = setTimeout(() => setCopied(false), 1600);
    return () => clearTimeout(t);
  }, [copied]);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
    } catch {
      /* the browser refused (no permission, not a secure page) — nothing was copied, so nothing says it was */
    }
  };
  return (
    <button type="button" onClick={() => { void copy(); }} title={title} aria-label={title}
      className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-[8px] hover:bg-warm-stone-light ${copied ? "text-sage-600" : "text-warm-muted"}`}
      data-testid={testId} data-copied={copied ? "true" : "false"}>
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d={copied ? DONE : COPY} />
      </svg>
    </button>
  );
}
